import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Box from 'shopper/components/Box';
import Text from 'shopper/components/Text';

import TopbarSearch from 'components/Topbar/TopbarSearch';

import { toCleanedSearchResultsPage } from 'lib/links';
import { toPtBrDecimalNumber } from 'lib/number';

import SearchQuerySuggestedCorrectionTooltip from './SearchQuerySuggestedCorrectionTooltip';

import { SEARCH_RESULTS_TYPES } from 'constants/searchResults';

const SearchBox = ({
  className,
  gaEventCategory,
  hasResults = true,
  searchQuerySuggestedCorrection = null,
  searchResultsCount = null,
  searchResultsType,
}) => (
  <>
    <Box
      className={twJoin(
        'gap-4 rounded-b-none rounded-t-2 p-4 xl:rounded-b-2',
        className
      )}
      full
    >
      <TopbarSearch
        gaEventCategory={gaEventCategory}
        id="search-search_page"
        searchResultsType={searchResultsType}
        withTrends={false}
      />
      {hasResults && (
        <div className="border-neutral-high-300 dark:border-neutral-low-300">
          <Text>
            Encontramos{' '}
            <b>{`${toPtBrDecimalNumber(searchResultsCount)} resultados`}</b>{' '}
            para esta busca:
          </Text>
        </div>
      )}
    </Box>
    {searchQuerySuggestedCorrection && (
      <SearchQuerySuggestedCorrectionTooltip
        className="mb-10 ml-4 mt-4 md:ml-0"
        onClick={() =>
          toCleanedSearchResultsPage(
            SEARCH_RESULTS_TYPES.GENERAL.PARAM,
            searchQuerySuggestedCorrection
          )
        }
      >
        Você quis dizer <b>{searchQuerySuggestedCorrection}</b>?
      </SearchQuerySuggestedCorrectionTooltip>
    )}
  </>
);

SearchBox.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
  hasResults: PropTypes.bool,
  searchQuery: PropTypes.string,
  searchQuerySuggestedCorrection: PropTypes.string,
  searchResultsType: PropTypes.shape({
    NAME: PropTypes.string.isRequired,
    QUERY: PropTypes.string.isRequired,
    TYPE: PropTypes.string,
    BUTTON_TEXT: PropTypes.string,
    GA_EVENT_ACTION_PREFIX: PropTypes.string,
    GENERAL_RESULTS_LIMIT: PropTypes.number.isRequired,
    SORT_OPTIONS: PropTypes.arrayOf(
      PropTypes.shape({
        isDefaultOption: PropTypes.bool.isRequired,
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      })
    ),
  }),
  searchResultsCount: PropTypes.number,
};

export default SearchBox;
